import form from "./schemas/form";
import validations from "./schemas/validations";
import { useEffect, useState } from "react";
import initialValues from "./schemas/initialValues";
import axios from "axios";
import { API_URL } from "../../../config";
import { useParams } from 'react-router-dom';
import {getLocationService, updateLocationService} from "../../../services/locationService";
import {getDoctorService, listDoctorsService, updateDoctorService} from "../../../services/doctorService";
import {getPatientService, updatePatientService} from "../../../services/patientService";
import {capitalizeFirstLetter} from "../../../helpers/helpers";

const useEditPatient = () => {

    const { id } = useParams();

    const {formId, formField} = form;

    const [values, setValues] = useState(initialValues);
    const [doctors, setDoctors] = useState([]);

    const [isLoading, setIsLoading] = useState(true);

    const [snackbarConfig, setSnackbarConfig] = useState({
        color: 'success',
        title: '',
        message: '',
        icon: 'notifications'
    });
    const [show, setShow] = useState(false);
    const toggleSnackbar = () => setShow(!show);

    useEffect(() => {
        const init = async () => {
            setIsLoading(true);
            await loadDoctors();
            await loadRecord();
            setIsLoading(false);
        };

        init();
    }, []);

    const loadDoctors = async () => {

        try {

            const response = await listDoctorsService({
                sort: 'name',
                direction: 'asc',
                active: true
            });

            if(response.data.data.length > 0)
                setDoctors([{id: -1, label: "Selecciona una opción"}, ...response.data.data.map(doctor => ({id: doctor.id, label: capitalizeFirstLetter(doctor.name)}))]);

        } catch (error) {

            setSnackbarConfig({
                message: "Ocurrió un error cargando los doctores",
                icon: 'cancel',
                title: 'Doctores',
                color: 'warning'
            });

            setShow(true);

        }
    };

    const loadRecord = async () => {
        try {
            const response = await getPatientService(id);
            setValues(response.data.data);

        } catch (error) {
            setSnackbarConfig({
                message: "Algo salió mal cargando el paciente",
                icon: 'cancel',
                title: 'Pacientes',
                color: 'warning'
            });

            setShow(true);
        }
    };

    const handleSubmit = async (values, actions) => {
        try {
            // Send data to API
            await updatePatientService(id, values)

            setSnackbarConfig({
                message: 'Paciente actualizado exitosamente',
                icon: 'notifications',
                title: 'Pacientes',
                color: 'success'
            });

            setShow(true);

        } catch (error) {

            setSnackbarConfig({
                message: error.response.data.message,
                icon: 'cancel',
                title: 'Pacientes',
                color: 'warning'
            });

            setShow(true);
        }

        actions.setSubmitting(false);
    };

    return {
        doctors,
        formId,
        formField,
        validations,
        values,
        isLoading,
        snackbarConfig,
        show,
        toggleSnackbar,
        handleSubmit
    }
};

export default useEditPatient;
